import useLaunchDarklyFlag from '../../hooks/useLaunchDarklyFlag';

export const DISPATCH_TAB_FLAG_KEY = 'supervisor-dashboard-dispatch';

// Fails closed: the Dispatch tab stays hidden until LD resolves the flag true.
export default function useDispatchTabFlag() {
  return Boolean(useLaunchDarklyFlag(DISPATCH_TAB_FLAG_KEY));
}
